import { createGlobalStyle } from 'styled-components'

import { colors } from '@/styles'

import air_conditioning from './icons/air_conditioning.svg'
import amenity_lounge from './icons/amenity_lounge.svg'
import balcony from './icons/balcony.svg'
import bed from './icons/bed.svg'
import business_centre from './icons/business_centre.svg'
import cable from './icons/cable.svg'
import caretaker from './icons/caretaker.svg'
import courtyard from './icons/courtyard.svg'
import dishwasher from './icons/dishwasher.svg'
import dryer from './icons/dryer.svg'
import facebook from './icons/facebook.svg'
import fridge from './icons/fridge.svg'
import gym from './icons/gym.svg'
import instagram from './icons/instagram.svg'
import kids_area from './icons/kids_area.svg'
import lounge from './icons/lounge.svg'
import map_location from './icons/map_location.svg'
import meal from './icons/meal.svg'
import media_room from './icons/media_room.svg'
import meeting_room from './icons/meeting_room.svg'
import parking from './icons/parking.svg'
import pets from './icons/pets.svg'
import plane from './icons/plane.svg'
import rooftop_patio from './icons/rooftop_patio.svg'
import room from './icons/room.svg'
import shopping_bag from './icons/shopping_bag.svg'
import shopping_cart from './icons/shopping_cart.svg'
import skyline from './icons/skyline.svg'
import stove from './icons/stove.svg'
import twitter from './icons/twitter.svg'
import washer from './icons/washer.svg'
import wifi from './icons/wifi.svg'
import yoga_room from './icons/yoga_room.svg'

const W1Style = createGlobalStyle`
body {
  font-family: 'Open Sans', sans-serif;
}

.primary-title {
  color: #87724d;
  font-size: 36px;
  font-weight: 500;
  letter-spacing: 0.64px;
  line-height: 49px;
}

.secondary-title {
  color: #87724d;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.43px;
  line-height: 33px;
}

.secondary-title.small {
  font-size: 18px;
  letter-spacing: 0.32px;
  line-height: 24px;
}

.primary-button {
  height: 45px;
  width: 180px;
  background-color: #87724d;
  color: ${colors.white};
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.32px;
  box-shadow: 1px 2px 10px ${colors.black};
  line-height: 48px;
  text-align: center;
  text-decoration: none;
  animation: pulse 1.5s ease-out 3;
}

.primary-button:hover {
  background-color: #9b8357;
  border: 1px ${colors.white};
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: 0.3s;
  transform: scale(1.05);
  animation: none;
}

.sticky-button {
  height: 40px;
  width: 160px;
  background-color: #fe5f55;
  color: ${colors.white};
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.32px;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
}

@keyframes pulse {
  from {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);
  }
  to {
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0);
  }
}

.container {
  margin: 0 auto;
}

@media screen and (min-width: 1024px) {
}

@media screen and (min-width: 1500px) {
  .container {
    max-width: 1440px;
  }
  .content-footer .content-item.left {
    flex: 0 1 696px;
  }
}

.page-header {
  height: 80px;
  background: ${colors.white};
  display: flex;
  align-items: center;
  padding: 0 60px;
  justify-content: space-between;
  text-decoration: none;
}

.page-footer {
  height: 60px;
  background: ${colors.white};
  display: flex;
  align-items: center;
  padding: 0 60px;
}

.page-footer .copyright {
  color: #303030;
  font-size: 13px;
  letter-spacing: -0.3px;
  line-height: 16px;
  margin-left: 10px;
}

.page-footer .social-buttons {
  display: flex;
  justify-content: space-around;
  margin-left: auto;
}

.banner-section {
  height: 716px;
  overflow: hidden;
  position: relative;
}

.banner-image {
  transition: transform 5s ease-out, -webkit-transform 5s ease-out;
  display: block;
  width: 100%;
  height: 100%;
}

.banner-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  z-index: 2;
}

.banner-content .box-title {
  width: 620px;
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 157px;
}

.banner-content .banner-title {
  width: 450px;
  color: ${colors.white};
  font-size: 48px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 65px;
  text-align: center;
  text-shadow: 3px 3px 12px ${colors.black}, 2px 2px 1px ${colors.black};
  padding-bottom: 15px;
}

.banner-content .banner-subtitle {
  width: 540px;
  color: ${colors.white};
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 36px;
  text-align: center;
  text-shadow: 3px 3px 10px ${colors.black}, 2px 2px 1px ${colors.black};
  padding-bottom: 30px;
}

.banner-content .banner-company-logo {
  margin-top: auto;
  align-self: flex-end;
  margin-bottom: -6px;
}

.cta-section {
  padding-top: 70px;
  text-align: center;
}

.cta-section .cta-action-box {
  margin: 50px auto 0 auto;
}

.cta-section .cta-buttons {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.cta-section .cta-section-button {
  width: 260px;
  text-decoration: none;
}

.cta-features {
  display: flex;
  justify-content: space-around;
  max-width: 1000px;
  margin: 106px auto 0 auto;
}

.cta-features .cta-feature-item {
  flex: 0 1 280px;
}

.cta-features .cta-feature-item .cta-feature-header {
  margin-bottom: 35px;
  height: 103px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.cta-features .cta-feature-item .w1-icon {
  width: 56px;
  height: 56px;
  background-size: 56px 56px;
}

.cta-features .cta-feature-item .cta-feature-title {
  color: #87724d;
  font-size: 19.7px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 27px;
  text-align: center;
}

.cta-features .cta-feature-item .cta-feature-text {
  color: #87724d;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 19px;
  text-align: center;
  margin: 0;
}

.content-section {
  margin-top: 80px;
  display: flex;
  align-items: stretch;
}

.content-section img {
  display: block;
}

.content-section .content-left {
  flex: 0 1 407px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.come-home {
  display: flex;
  height: 393px;
  margin-bottom: 10px;
}

.come-home .text {
  padding-left: 20px;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.43px;
  line-height: 33px;
}

.come-home .first {
  padding-top: 160px;
  flex: 1 1 50%;
  color: #87724d;
  text-align: right;
  padding-right: 20px;
}

.come-home .last {
  flex: 0 1 213px;
  background-color: #87724d;
  padding-top: 198px;
  color: ${colors.white};
}

.content-section .content-right {
  flex: 0 1 1014px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 20px;
}

.content-section .content-right .bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}

.content-section .content-right .bottom .features-section {
  flex: 1 0 335px;
}

.features-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-section .features-list {
  margin: 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 335px;
}

.features-section .features-list.five-per-row {
  flex-basis: 415px;
}

.features-section .features-list.six-per-row {
  flex-basis: 500px;
}

.amenities .features-section .features-list {
  display: none;
  min-height: 226px;
}

.amenities .features-section .features-list.visible {
  display: flex;
}

.features-section .disclaimer {
  color: #87724d;
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  letter-spacing: 0.21px;
  line-height: 17px;
  margin: 20px 0 0 0;
  max-width: 490px;
}

.features-container {
  display: flex;
  justify-content: center;
}

.features-list .feature-item {
  width: 83px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
}

.features-list .feature-item .feature-item-text {
  display: block;
  color: #87724d;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 14px;
  text-align: center;
}

.features-list .feature-item .feature-item-text-cn {
  display: block;
  color: #87724d;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 14px;
  text-align: center;
}

.features-list .feature-item .w1-icon {
  margin-bottom: 10px;
}

.content-footer {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.content-footer.spacing-top {
  margin-top: 15px;
}

.content-footer .content-item {
  display: flex;
  flex: 1;
  align-items: center;
}

.content-footer .full {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.liv-marketing {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 252px;
  margin-top: 42px;
}

.liv-marketing .secondary-title {
  text-decoration: none;
}

.section-map {
  margin-top: 20px;
  height: 394px;
}

#map {
  height: 394px;
}

.section-disclaimer {
  margin: 50px 50px 60px 50px;
}

.amenities .tabs {
  margin-top: 16px;
}

.amenities .tab:last-child {
  margin-left: 20px;
}

.section-disclaimer .disclaimer {
  color: #87724d;
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  letter-spacing: 0.21px;
  line-height: 17px;
}

.hidden {
  display: none !important;
}

.tabs .tab {
  color: #87724d;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 22px;
  text-align: center;
  text-decoration: none;
}

.tabs .tab.active {
  text-decoration: underline;
}

.w1-icon {
  width: 48px;
  height: 48px;
  display: inline-block;
  background: transparent center/48px 48px no-repeat;
}

.w1-icon.air-conditioning {
  background-image: url(${air_conditioning});
}

.w1-icon.amenity-lounge {
  background-image: url(${amenity_lounge});
}

.w1-icon.business-centre {
  background-image: url(${business_centre});
}

.w1-icon.kids-area {
  background-image: url(${kids_area});
}

.w1-icon.facebook {
  background-image: url(${facebook});
}

.w1-icon.instagram {
  background-image: url(${instagram});
}

.w1-icon.map-location {
  background-image: url(${map_location});
}

.w1-icon.meal {
  background-image: url(${meal});
}

.w1-icon.shopping-bag {
  background-image: url(${shopping_bag});
}

.w1-icon.twitter {
  background-image: url(${twitter});
}

.w1-icon.balcony {
  background-image: url(${balcony});
}

.w1-icon.bed {
  background-image: url(${bed});
}

.w1-icon.caretaker {
  background-image: url(${caretaker});
}

.w1-icon.courtyard {
  background-image: url(${courtyard});
}

.w1-icon.dishwasher {
  background-image: url(${dishwasher});
}

.w1-icon.gym {
  background-image: url(${gym});
}

.w1-icon.bed {
  background-image: url(${bed});
}

.w1-icon.dryer {
  background-image: url(${dryer});
}

.w1-icon.washer {
  background-image: url(${washer});
}

.w1-icon.lounge {
  background-image: url(${lounge});
}

.w1-icon.parking {
  background-image: url(${parking});
}

.w1-icon.pets {
  background-image: url(${pets});
}

.w1-icon.media-room {
  background-image: url(${media_room});
}

.w1-icon.plane {
  background-image: url(${plane});
}

.w1-icon.skyline {
  background-image: url(${skyline});
}

.w1-icon.shopping-cart {
  background-image: url(${shopping_cart});
}

.w1-icon.fridge {
  background-size: 24px;
  background-image: url(${fridge});
}

.w1-icon.stove {
  background-image: url(${stove});
}

.w1-icon.wifi {
  background-size: 26px;
  background-image: url(${wifi});
}

.w1-icon.cable {
  background-size: 32px 24px;
  background-image: url(${cable});
}

.w1-icon.meeting-room {
  background-image: url(${meeting_room});
}

.w1-icon.room {
  background-image: url(${room});
}

.w1-icon.yoga-room {
  background-image: url(${yoga_room});
}

.w1-icon.rooftop-patio {
  background-image: url(${rooftop_patio});
}

.tablet-only {
  display: none !important;
}

.sticky-buttons {
  background: ${colors.white};
  width: 100%;
  height: 60px;
  position: fixed;
  z-index: 9000;
  bottom: 0;
  left: 0;
  transition: transform 0.7s ease-in;
  overflow: hidden;
  opacity: 1;
  transform: translateY(0);
  box-shadow: 0 -2px 4px 1px rgba(0, 0, 0, 0.2);
}

.sticky-buttons.hidden {
  transform: translateY(100%);
}

.sticky-buttons.force-hidden {
  transform: translateY(100%);
}

.sticky-buttons .logo {
  width: auto;
  display: inline-block;
}

.sticky-buttons .logo img {
  height: 100%;
}

.sticky-buttons .sticky-buttons-container {
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: space-between;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 940px;
}

.sticky-buttons-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}

.sticky-buttons-content .text {
  margin: 0;
  font-size: 16px;
}

.sticky-buttons-content .ios {
  margin: 0 22px;
}

.sticky-buttons-content-buttons {
  display: flex;
}

.sticky-buttons-content-buttons .sticky-buttons-button {
  height: 42px;
  width: auto;
  flex-shrink: 0;
  display: inline-block;
}

.sticky-buttons-content-buttons img {
  height: 100%;
}

.sticky-buttons .icon-button {
  border: none;
  background: none;
  cursor: pointer;
  width: 14px;
  height: 14px;
  padding: 0;
  align-self: flex-start;
  margin-top: 30px;
  margin-left: 10px;
  flex-grow: 0;
  background-size: 14px 14px;
  text-indent: -9999px;
  overflow: hidden;
  outline: none;
}

/* NON MOBILE */

@media screen and (min-width: 599px) {
  .mobile-only {
    display: none !important;
  }
  .amenities .features-section .features-list.smaller {
    flex-basis: 338px;
  }
}

@media (max-width: 991px) {
  .sticky-buttons .sticky-buttons-container {
    margin: 0 20px;
  }
  .sticky-buttons .icon-button {
    right: 20px;
  }
  .sticky-buttons .text {
    text-align: right;
  }
  .sticky-buttons .top-text {
    display: block;
  }
}

/* TABLET - Landscape */

@media screen and (min-width: 768px) and (max-width: 1096px) {
  .features-section .disclaimer {
    margin: 20px;
  }
  .content-section .content-right .bottom .images {
    align-self: flex-end;
  }
  .content-section .content-right .bottom .images .xs-right {
    max-width: 200px;
  }
  .content-footer.amenities {
    margin-top: 20px;
  }
  .come-home .first {
  }
  .come-home .last {
    flex: 1 1 50%;
  }
  .come-home .text {
    padding-right: 0px;
    text-align: left;
  }
}

/* END TABLET - Landscape */

@media screen and (max-width: 775px) {
  .sticky-buttons .top-text {
    display: none;
  }
  .sticky-buttons {
    height: 60px;
  }
  .sticky-button-logo {
    width: 55px;
    height: 55px;
    object-fit: cover;
    object-position: left;
  }
  .sticky-buttons-content {
    flex-direction: row;
    flex: initial;
  }
  .sticky-button {
    width: 140px;
    font-size: 14px;
  }
  .sticky-buttons-content .text {
    font-size: 14px;
  }
  .sticky-buttons-content-buttons {
    margin-top: 2px;
  }
  .sticky-buttons-content-buttons .sticky-buttons-button {
    height: 32px;
  }
  .sticky-buttons-content .ios {
    margin: 0 12px 0 0;
  }
  .sticky-buttons .icon-button {
    margin-top: 20px;
  }
  .sticky-buttons .logo {
    width: 55px;
    height: 45px;
  }
}

/* TABLET - Portrait */

@media screen and (min-width: 600px) and (max-width: 775px) {
  .tablet-hidden {
    display: none !important;
  }
  .tablet-only {
    display: inline !important;
  }
  .sticky-button-logo {
    width: 65px;
    object-fit: cover;
    object-position: left;
  }
  .banner-section {
    height: 400px;
  }
  .banner-content .box-title {
    width: 295px;
    height: 107px;
    background-color: rgba(0, 0, 0, 0);
    margin-top: 79px;
    padding: 0 15px;
  }
  .banner-content .banner-title {
    width: 240px;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.46px;
    line-height: 28px;
  }
  .banner-content .banner-subtitle {
    width: 320px;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.46px;
  }
  .banner-content .banner-company-logo {
    width: 140px;
  }
  .primary-title {
    font-size: 16px;
    letter-spacing: 0.29px;
    line-height: 22px;
  }
  .secondary-title {
    font-size: 18px;
    letter-spacing: 0.32px;
    line-height: 18px;
  }
  .cta-section {
    padding-top: 40px;
  }
  .cta-features {
    flex-direction: column;
    width: 530px;
    margin-top: 10px;
  }
  .cta-features .cta-feature-item {
    margin-top: 40px;
    flex-basis: auto;
  }
  .cta-features .cta-feature-item .cta-feature-header {
    margin-bottom: 20px;
  }
  .cta-section .cta-section-button {
    width: 230px;
    font-size: 16px;
  }
  .content-section .content-right {
    margin-left: 0;
    flex: 1;
  }
  .content-section .content-right .bottom {
    margin-top: 8px;
    align-items: unset;
  }
  .content-section .content-right .bottom .images {
    display: flex;
    align-items: flex-end;
    flex: 0 1 48%;
    justify-content: space-between;
  }
  .content-section .content-right .bottom .images .tablet-left {
    max-width: 59.5%;
  }
  .content-section .content-right .bottom .images .xs-right {
    max-width: 39.5%;
  }
  .content-footer {
    flex-direction: column;
  }
  .content-footer.amenities {
    flex-direction: column-reverse;
    margin-top: 20px;
  }
  .content-footer.spacing-top {
    margin-top: 60px;
  }
  .features-section .features-list {
    margin-bottom: 0;
  }
  .content-footer .content-footer-picture {
    object-fit: cover;
    width: 100%;
  }
  .content-footer.amenities .content-item.left {
    margin-top: 60px;
  }
  .content-footer .liv-info {
    width: 296px;
    margin: 60px auto;
  }
  .liv-marketing {
    margin-top: 30px;
    width: 190px;
  }
}

/* END TABLET */

/* MOBILE */

@media screen and (max-width: 599px) {
  .mobile-hidden {
    display: none !important;
  }
  .mobile-only {
    display: inline !important;
  }
  .page-header {
    padding: 0 50px;
    display: flex;
    justify-content: space-between;
  }
  .primary-button {
    height: 45px;
    width: 180px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.32px;
    line-height: 42px;
  }
  .page-footer {
    margin: 0 30px;
    border-top: 1px solid #ccc;
    height: 200px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .page-footer .copyright {
    margin-top: 18px;
    margin-left: 0;
    order: 3;
  }
  .page-footer .social-buttons {
    margin-left: 0;
    justify-content: center;
    margin-top: 18px;
  }
  .content-section {
    flex-direction: column;
  }
  .content-section .content-left {
    flex-basis: auto;
  }
  .content-section .content-right {
    margin-left: 0;
    flex-basis: auto;
  }
  .content-section .content-right .bottom {
    flex-direction: column;
  }
  .content-section .content-right .bottom .images {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .content-section .content-right .bottom .images .xs-left {
    width: calc(65% - 10px);
  }
  .content-section .content-right .bottom .images .xs-right {
    width: 35%;
    display: inline-block;
  }
  .content-footer {
    flex-direction: column;
  }
  .content-footer.amenities {
    flex-direction: column-reverse;
  }
  .come-home .first {
    padding: 160px 20px 0 0;
    text-align: right;
  }
  .come-home .last {
    flex: 1 1 50%;
  }
  .primary-title {
    font-size: 22px;
    line-height: 26px;
  }
  .secondary-title {
    font-size: 20px;
    line-height: 18px;
    margin-top: 0;
  }
  .cta-section .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  .cta-section .cta-section-button {
    margin-top: 20px;
  }
  .cta-features {
    flex-direction: column;
    margin-top: 0;
  }
  .cta-features .cta-feature-item {
    flex: auto;
    margin-top: 50px;
  }
  .banner-section {
    height: 400px;
  }
  .banner-content .box-title {
    margin-top: 125px;
    width: 295px;
    height: 107px;
    background-color: rgba(0, 0, 0, 0);
  }
  .banner-content .banner-title {
    width: 220px;
    font-size: 22px;
    line-height: 30px;
  }
  .banner-content .banner-subtitle {
    width: 295px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
  .banner-content .banner-company-logo {
    max-width: 100px;
  }
  .cta-section {
    margin: 0 auto;
    padding: 0 20px;
    margin-top: 30px;
  }
  .features-section {
    padding: 40px 0;
  }
  .features-section .features-list {
    flex-basis: 335px !important;
  }
  .features-section .features-list.six-per-row {
    flex-basis: 335px;
  }
  .content-section .content-right .bottom .features-section {
    flex-basis: auto;
  }
  .liv-info {
    padding: 40px 0;
  }
  .liv-info .secondary-title {
    text-align: center;
  }
  .liv-marketing {
    width: 205px;
    margin-top: 30px;
  }
  .section-disclaimer {
    margin: 50px 20px;
  }
  .features-section .disclaimer {
    margin-left: 20px;
    margin-right: 20px;
  }
  .sticky-buttons .sticky-buttons-container {
    margin: 0 20px;
  }
}

@media (max-width: 320px) {
  .small-mobile-hidden {
    display: none !important;
  }
  .sticky-buttons .sticky-buttons-container {
    margin-right: 20px;
  }
  .sticky-buttons-content {
    flex: 1;
  }
}

.map-marker {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #87724d;
}

.map-marker:after {
  content: ' ';
  width: 56px;
  height: 56px;
  background: url(${skyline}) 50% 50%/30px no-repeat;
  position: absolute;
}

.copyright-icons {
  position: absolute;
  left: -99999px;
}
`

export default W1Style
